import React from 'react';
import { IonIcon } from '@ionic/react';
import { informationCircleOutline, warningOutline } from 'ionicons/icons';
import ToggleSwitch from './ToggleSwitch';
import './TogglePanel.css';

interface TogglePanelProps {
  /** Label text displayed on the left side */
  label: string;
  /** Show warning triangle icon to the left of label */
  showWarningIcon?: boolean;
  /** Show info icon next to label */
  showInfoIcon?: boolean;
  /** Callback fired when info icon is clicked */
  onInfoClick?: () => void;
  /** Initial state of the toggle */
  defaultChecked?: boolean;
  /** Controlled value (if provided, component becomes controlled) */
  checked?: boolean;
  /** Callback fired when toggle state changes */
  onChange?: (checked: boolean) => void;
  /** Disable the toggle */
  disabled?: boolean;
  /** Additional CSS class name */
  className?: string;
  /** Parameterizes CSS classes if we need custom styling of the label for certain partners/contexts.*/
  labelClassName?: string;
}

function TogglePanel({
  label,
  showWarningIcon = false,
  showInfoIcon = false,
  onInfoClick,
  defaultChecked = false,
  checked,
  onChange,
  disabled = false,
  className = '',
  labelClassName,
}: TogglePanelProps) {
  const handleInfoClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onInfoClick) {
      onInfoClick();
    } else {
      console.log('Info icon clicked for:', label);
    }
  };

  return (
    <div className={`toggle-panel ${className}`}>
      <div className="toggle-panel__label-container">
        {showWarningIcon && (
          <IonIcon
            icon={warningOutline}
            className="toggle-panel__warning-icon"
          />
        )}
        <span className={`toggle-panel__label ${labelClassName || ''}`}>{label}</span>
        {showInfoIcon && (
          <IonIcon
            icon={informationCircleOutline}
            className="toggle-panel__info-icon"
            onClick={handleInfoClick}
          />
        )}
      </div>
      <ToggleSwitch
        defaultChecked={defaultChecked}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
}

export default TogglePanel;

